import { createElement, FC } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import CheckIcon from '@/components/ui/icons/CheckIcon.tsx';
import { cn } from '@/utils/classNames.ts';
import { SvgProps } from '@/components/shared/Svg/Svg.tsx';

type CheckIconBlockProps = PropsWithClassName<{
  icon?: FC<SvgProps>;
}>;

const CheckIconBlock: FC<CheckIconBlockProps> = ({ className, icon }) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full border border-primary bg-[#EFE6D5] w-20 h-20',
        className
      )}
    >
      {icon ? (
        createElement(icon, { className: 'text-primary', style: { width: '41%', height: 'auto' } })
      ) : (
        <CheckIcon className="text-primary" style={{ width: '41%', height: 'auto' }} />
      )}
    </div>
  );
};

export default CheckIconBlock;
